export const AppConfig = {
  assets: {
    lockedThumbnailUrl: "https://assets.iyk.app/music/fans/locked-unlock-thumbnail.jpg",
    asteriskLottieUrl: "https://assets.iyk.app/lottie/reveal-asterisk.lottie"
  }
}
